import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { Navigate } from 'react-router-dom'
import { useAuth } from './core/Auth'
import { getLoginRedirectPath } from './core/AuthHelpers'
import { getEmpresaSlugFromLoginPath, prefetchLoginCompanyConfig } from './core/loginCompanyConfig'

export function Logout() {
  const { logout } = useAuth()
  const queryClient = useQueryClient()
  const [isLoggedOut, setIsLoggedOut] = useState(false)
  const loginRedirectPath = getLoginRedirectPath()

  useEffect(() => {
    let isMounted = true

    const executeLogout = async () => {
      // Em paralelo com o logout: o login da empresa já abre com a imagem lateral e o logo dela,
      // sem piscar os da Lauduz enquanto a configuração carrega.
      await Promise.all([
        logout(),
        prefetchLoginCompanyConfig(queryClient, getEmpresaSlugFromLoginPath(loginRedirectPath)),
      ])
      if (isMounted) {
        setIsLoggedOut(true)
      }
    }

    executeLogout()

    return () => {
      isMounted = false
    }
  }, [logout, loginRedirectPath, queryClient])

  return isLoggedOut ? <Navigate to={loginRedirectPath} replace /> : null
}
